import { ComponentPropsWithoutRef, ForwardRefExoticComponent, PropsWithChildren, useMemo } from 'react';

import { RouterContext } from './RouterContext';

export interface RouterProviderProps {
  /**
   * Any routes to blacklist from using LinkComponent. Uses `minimatch` to check against URL subpath. Any matching
   * routes will not use LinkComponent and will instead use default `<a>' tags
   */
  blacklist?: Array<string>;
  /**
   * When set this will also supply the href to this prop on the LinkComponent. e.g. `hrefProp: 'to'` for react-router-dom `<Link to="x">`
   */
  hrefProp?: string;
  LinkComponent: ForwardRefExoticComponent<ComponentPropsWithoutRef<'a'>>;
}

export function RouterProvider({ children, blacklist, hrefProp, LinkComponent }: PropsWithChildren<RouterProviderProps>) {
  const ctx = useMemo(
    () => ({
      blacklist,
      hrefProp,
      LinkComponent,
    }),
    [blacklist, hrefProp, LinkComponent]
  );

  return <RouterContext.Provider value={ctx}>{children}</RouterContext.Provider>;
}
